"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Types_1 = require("@/Types");
const Utils_1 = require("@/Utils");
const useTranslate_1 = require("@/Hooks/useTranslate");
const RotatingLoader_1 = __importDefault(require("@/Components/UI/RotatingLoader/RotatingLoader"));
const InfoBlock_1 = __importDefault(require("../InfoBlock/InfoBlock"));
const AddToCart_1 = __importDefault(require("@/Components/UI/AddToCart/AddToCart"));
const useUserData_1 = __importDefault(require("@/Hooks/useUserData"));
const useCommercePermissions_1 = __importDefault(require("@/Hooks/useCommercePermissions"));
const Hooks_1 = require("@/Hooks");
const FOUR_ROWS_HEIGHT = 130;
const MARGINS = 30;
const LIST_NAME = 'Product Listing Page';
const ProductCardBlock = ({ variant, type, withAddButton = false, onAmountChange, withCompareFunctionality, isCompareLoading, compareProductPartNumbers, setCompareProductPartNumbers, listIndex, breadcrumbs, listName }) => {
    const { prices, pkgAmount, pkgDescription, totalPrice, productCode, stocks, productionStatusCode, unit, quantity, price } = variant;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [showMoreButton, setShowMoreButton] = (0, react_1.useState)(false);
    const listRef = (0, react_1.useRef)(null);
    const { t } = (0, useTranslate_1.useTranslate)();
    const { stockStatus } = (0, Hooks_1.useStockStatus)(stocks, productionStatusCode);
    const userData = (0, useUserData_1.default)();
    const { canSeePrice } = (0, useCommercePermissions_1.default)(type, prices, stockStatus);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        let sum = 0;
        if (listRef === null || listRef === void 0 ? void 0 : listRef.current) {
            for (let i = 0; i < ((_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length); i++) {
                const child = listRef.current.children[i];
                sum += child.offsetHeight;
            }
        }
        if (sum > FOUR_ROWS_HEIGHT) {
            setShowMoreButton(true);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        if (listRef.current) {
            if (isOpen === false && !showMoreButton) {
                listRef.current.style.maxHeight = `100%`;
            }
            else if (isOpen === false) {
                listRef.current.style.maxHeight = `${FOUR_ROWS_HEIGHT}px`;
            }
            else {
                let sum = 0;
                for (let i = 0; i < ((_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length); i++) {
                    const child = ((_c = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _c === void 0 ? void 0 : _c.children) && ((_d = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _d === void 0 ? void 0 : _d.children[i]);
                    sum += child.offsetHeight;
                }
                listRef.current.style.maxHeight = sum + MARGINS + 'px';
            }
        }
    }, [isOpen, showMoreButton]);
    const getPrice = () => {
        if (type === Types_1.VariantTypes.MINI_CART_VIEW && totalPrice) {
            return !totalPrice || totalPrice.amount === 0
                ? t('/haldex/add_to_cart/no_price')
                : `${(0, Utils_1.currencyEncoder)(totalPrice.currencyCode)}${(0, Utils_1.priceEncoder)(totalPrice.amount)}`;
        }
        else {
            return (0, Utils_1.generateAddToCartPriceString)(prices, t);
        }
    };
    const { unitDecode } = (0, Hooks_1.useUnits)();
    return (react_1.default.createElement(styled.Container, { variantType: type },
        isLoading && (react_1.default.createElement(styled.LoaderContainer, null,
            react_1.default.createElement(RotatingLoader_1.default, null))),
        react_1.default.createElement(InfoBlock_1.default, { variant: variant, isOpen: isOpen, setIsOpen: setIsOpen, showMoreButton: showMoreButton, listRef: listRef, type: type, withCompareFunctionality: withCompareFunctionality, isCompareLoading: isCompareLoading, compareProductPartNumbers: compareProductPartNumbers, setCompareProductPartNumbers: setCompareProductPartNumbers, canSeePrice: canSeePrice, breadcrumbs: breadcrumbs }),
        react_1.default.createElement(AddToCart_1.default, { type: type, code: productCode === null || productCode === void 0 ? void 0 : productCode.value, isLoading: isLoading, setIsLoading: setIsLoading, price: getPrice(), unit: (0, Utils_1.getProductUnit)(prices, pkgAmount), multiple: pkgDescription || unit, packageSize: stocks && stocks[0].packageSize, onAmountChange: onAmountChange, withAddButton: withAddButton, stockStatus: stockStatus, isAuthenticated: userData === null || userData === void 0 ? void 0 : userData.isAuthenticated, additionalCharge: (0, Utils_1.getAdditionalCharge)(prices), prices: prices, quantity: quantity, miniCartUnitPrice: price, discountInfo: prices && prices.length > 1 && (0, Utils_1.getDiscountData)(t, prices, unitDecode), productName: variant.productName, partNumber: variant.partNumber || variant.productId, productBrand: variant.productLine, productLineLogo: variant.productLineLogo, breadcrumbs: variant.breadcrumb || variant.breadcrumbs, productionStatusCode: variant.productionStatusCode, customerSpecificCode: variant.customerSpecificCode, listIndex: listIndex, listName: listName || LIST_NAME })));
};
exports.default = (0, react_1.memo)(ProductCardBlock);
